import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react"
import mrMonopolyImage from "@/images/mr-monopoly/timer-auction.png"
import classNames from "classnames"

interface TimerProps {
  initialTime: number // Initial time in seconds
  totalTime: number // Total time in seconds
  onTimeout: () => void
  onChange: (value: number) => void
  paused?: boolean // Whether the timer is paused
}

export interface TimerRef {
  resetTimer: () => void // Function to reset the timer
}

const Timer = forwardRef<TimerRef, TimerProps>(
  ({ initialTime, totalTime, onTimeout, paused = false, onChange }, ref) => {
    return null
    const [currentTime, setCurrentTime] = useState(initialTime)

    useImperativeHandle(ref, () => ({
      resetTimer: () => {
        setCurrentTime(initialTime)
      },
    }))

    // Sync timer when initialTime changes externally
    useEffect(() => {
      setCurrentTime(initialTime)
    }, [initialTime])

    useEffect(() => {
      if (currentTime > 0 && !paused) {
        const interval = setInterval(() => {
          setCurrentTime((prevTime) => {
            const nextTime = Math.max(prevTime - 1, 0)
            onChange(nextTime)
            return nextTime
          })
        }, 1000)
        return () => clearInterval(interval)
      } else if (currentTime === 0) {
        onTimeout()
      }
    }, [currentTime, paused])

    const progress = (currentTime / totalTime) * 100
    const progressColor = `hsl(${(progress / 100) * 120}, 100%, 50%)`

    return (
      <div className="flex flex-col gap-2 font-poppins w-fit">
        <div className="text-gray-300">Turn ending in:</div>
        <div
          className={classNames(
            "bg-auction flex gap-2 relative bg-auction-timerBackground text-white md:text-3xl text-xl items-center font-semibold px-6 py-3 font-mono pr-6 pl-4"
          )}
        >
          {/* <img src={mrMonopolyImage} className="h-auto" /> */}
          00:{String(currentTime).padStart(2, "0")}
          <div
            style={{
              width: `${progress}%`,
              backgroundColor: progressColor,
            }}
            className="absolute bottom-0 h-1 left-0 transition-all"
          ></div>
        </div>
      </div>
    )
  }
)
export default Timer
